import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Button, Tooltip, message } from 'antd';
import { VocabsIndividual, RdfTriplet } from '../../redux';
import { getValues } from '../../virtuoso/helper'
import { FieldViewProxy, FieldEditProxy } from '../adms/FieldProxies';
import SelectIndividualForm from '../editor/SelectIndividualForm';
import { getSelectedIRI } from '../editor/helper';
import PropertyLabel from '../owl/ProperyLabel';
import URILink from '../widgets/URILink';

/** Отображение списка значений для карточки skos:ConceptScheme
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const serviceFields = [];
const sortedStartPart = ["http://www.w3.org/1999/02/22-rdf-syntax-ns#about", "http://purl.org/dc/terms/language",
"http://www.w3.org/2000/01/rdf-schema#label", "http://purl.org/dc/terms/description"]
const sortedFinishPart = ["http://www.w3.org/2002/07/owl#versionInfo", "http://csi.semanticpro.org/2016/ns#prefix",
"http://www.w3.org/2000/01/rdf-schema#comment"]
const exclude = ["http://www.w3.org/ns/dcat#theme", "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", 
  "http://purl.semanticpro.org/ontologies/sksa/wiki", "http://hbz.ru/ontologies/emd/wiki", 
  "http://www.w3.org/ns/dcat#distribution", 
  "http://open-services.net/ns/cm#status"];

//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (factory, predicates, values) => {
    //console.log("const filterForShow = (factory, predicates, values)", predicates, values);
    //Исключаем служебные элементы. Пока их нет!
    const first = predicates.filter(key => !serviceFields.includes(key)); 
    //Исключаем свойства, которые не должны показываться
    const properties = first.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    //console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}

const { confirm } = Modal;
/** Формирует выподающий список для операций */
const ButtonGroup = Button.Group;
const SelectOperation = ({predicat, e, d, t, l, action}) =>{
    return  (
        <ButtonGroup style={{verticalAlign: "0em"}}>
            {e && <Button type="dashed" size="small" icon="edit" onClick={(e)=> action(e, "edit", predicat)}></Button>}
            {d && <Button type="dashed" size="small" icon="delete"  onClick={(e)=> action(e, "delete", predicat)}></Button>}
            {t && <Button type="dashed" size="small" icon="line-height" onClick={(e)=> action(e, "translate", predicat)}></Button>}
            {l && <Button type="dashed" size="small" icon="link" onClick={(e)=> action(e, "link", predicat)}></Button>}
        </ButtonGroup>
    )
}

/** Показать диалог выбора индивидуала */
const showSelectIndividual = (formRef=f=>f, IRI, predicat, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("syncPercent", syncPercent);
  return <Modal style={{minWidth: "80%"}} open={true} title="Выбор элемента" cancelText="Отмена" okText="Ок" 
    onCancel={onCancelOperation} onOk={onFinishOperation} okButtonProps={{disabled: !getSelectedIRI(selected)}}>
        <SelectIndividualForm formRef={formRef} IRI={IRI} predicat={predicat}
          factory={factory} lang={lang}/>
    </Modal>
}

/** Базовая компонента отображения свойств.
 * Обработка событий при модификации содрежимого происходит в родительской компоненте. 
 * Для этого из родительского компонента передаётся handlers
 */
class IndividualData extends React.Component {

  state = {
      selected: undefined,    //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перерво
      operation: "view",      //Текущая операция. Может быть view, edit, translate, delete

      linkSelectModal: false,
      linkSelectSubject: undefined,
      linkSelectPredicat: undefined,
      linkSelectResolve: undefined,
      linkSelectReject: undefined,
    };

  formRef = React.createRef();

  /** Вызывается после изменений при редактировании полей */
  onReloadProxy(subject, predicat){
    const {graph, onReload} = this.props;
    return onReload(subject, graph);
  };
  
    /** Обработчик действий над элементом в форме  */
  onAction (e, type, predicat) {
    e.preventDefault();
    //console.log("AssetData.js onAction", e, type, predicat); console.log(this); 
    //Режим редактирования, удаления или перевода
    if ((type=="edit")||(type=="translate")){
      const { iri, lang, values, onSelected} = this.props;
      const value = getValues(predicat, lang, values);
      this.setState({selected: predicat});
      onSelected(type, iri, predicat, value);
      return;
    }
    if (type=="delete"){      
        const { handlers } = this.props;
        //const value = getValues(predicat, this.props.lang, this.props.values);
        if (handlers) 
          handlers(e, predicat, type);
        return;
    }
    if (type=="cancel"){
        this.setState({selected: predicat, operation: "view"})
        return;
    }
    if (type=="detail"){
        const {handlers} = this.props;
        if (handlers) handlers(e, predicat, type);
    }
    //Добавление новой ссылки в объектное совойства
    if (type=="link" || type == "unlink"){
      this.setState({objectProperty: predicat, selected: predicat});
    }
    //Добавление новой ссылки c созданием объекта
    if (type=="new"){
      this.setState({selected: predicat});
    }
  }

  onSelectLink = ({ subject, predicat, factory }) => {
    return new Promise((resolve, reject) => {
        this.setState({ linkSelectModal: true, linkSelectSubject: subject, linkSelectPredicat: predicat,
          linkSelectResolve: resolve, linkSelectReject: reject,
        });
      });
  };

  onSelectLinkOk = () => {
    const { linkSelectResolve } = this.state;

    const selectedIRI = getSelectedIRI(this.props.vselected);

    if (!selectedIRI) {
      if (linkSelectResolve) {
        linkSelectResolve(undefined);
      }

      this.setState({ linkSelectModal: false,linkSelectSubject: undefined, linkSelectPredicat: undefined,
        linkSelectResolve: undefined, linkSelectReject: undefined, });

      return;
    }

    if (linkSelectResolve) { linkSelectResolve(selectedIRI); }

    this.setState({ linkSelectModal: false, linkSelectSubject: undefined, linkSelectPredicat: undefined, 
      linkSelectResolve: undefined, linkSelectReject: undefined });
  };

  onSelectLinkCancel = () => {
    const { linkSelectReject } = this.state;

    if (linkSelectReject) { linkSelectReject(new Error("Выбор объекта отменён.")); }

    this.setState({ linkSelectModal: false, linkSelectSubject: undefined, linkSelectPredicat: undefined,
      linkSelectResolve: undefined, linkSelectReject: undefined, });
  };  

  onAppendLink = (subject, predicat, objectIRI) => {
    console.log(this, subject, predicat, objectIRI);
    const { onInsertProperty, onReload, graph } = this.props;
    onInsertProperty(RdfTriplet, subject, predicat, objectIRI)
      .then (result =>{
          //Обновим каталог
          if (onReload)
            onReload(subject, graph).then(result2=> {
              message.success(i18n.t('components.editor.individual.message.ok_new'));
            });
          else{
            message.success("Для просмотра изменений перегрузите страницу.");
          };
      })
      .catch(info => {
        message.error(i18n.t('components.editor.individual.message.e_new', {detail: info}));
      });
  };

  onDeleteLink = (subject, predicat, objectIRI) => {
    const { onDeleteElement, onReload, graph } = this.props;
    onDeleteElement(RdfTriplet, subject, predicat, objectIRI)
      .then (result =>{
        //Обновим каталог
        if (onReload)
          onReload(subject, graph).then(result2=> {});
        else  
          message.success("Для просмотра изменений перегрузите страницу.");
      })
      .catch(info => {
        message.error(i18n.t('components.editor.individual.message.e_unlink', {detail: info}));
      });
  };

  onNewLink = ({ subject, predicat, values, factory }) => {
    const { linkHandlers } = this.props;

    if (linkHandlers && typeof linkHandlers.onNewLink === "function") {
      return linkHandlers.onNewLink({ subject, predicat, values, factory });
    }

    return undefined;
  };  

  render(){
    //console.log(this); 
    const {predicates, values, lang, factory, operation, vselected, iri, handlers, types, addedPredicates} = this.props;
    const properties =  filterForShow(factory, predicates, values);
    const addedProperies = Array.isArray(addedPredicates)? addedPredicates.map(item => item.predicat.value):[];
    //Временно отключим редактирование и удаление свой-ва в карточке
    const FieldProxy = (operation=="edit")? FieldEditProxy: FieldViewProxy;
    const linkProps = {
      onSelectLink: this.onSelectLink,
      onAppendLink: this.onAppendLink,
      onDeleteLink: this.onDeleteLink,
      //onNewLink: this.onNewLink,
    };
    const labelStyle = operation=="edit" ? { color: '#bfbfbf' } : undefined;
    return (
      <span>
        <Row className="assetCardTable_tr" style={labelStyle}> 
          <Col span={10} className="assetCardTable_td"><div className="csi_field_div">URI</div></Col>
          <Col span={14} className="assetCardTable_td">
            <div className="csi_value_div">
              <URILink uri={iri} factory={factory} operation={operation}/>
            </div>
          </Col>
        </Row>
        {properties.map((prop) => 
          <Row key={prop} className="assetCardTable_tr"> 
            <Col span={10} className="assetCardTable_td">
              <PropertyLabel iri={prop} factory={factory}/>
            </Col>
            <Col span={14} className="assetCardTable_td" style={{display: "block"}}>
              <FieldProxy 
                factory={factory} lang={lang} 
                subject={iri} predicat={prop} values={values} vselected={vselected}
                onReload={(subject, predicat) => this.onReloadProxy(subject, predicat)}
                getBaseRoutePath={this.props.getBaseRoutePath}
                {...this.state} 
                {...linkProps}
                action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
            </Col>
          </Row>
        )}
        {Array.isArray(addedProperies) && 
          addedProperies.map((prop) => 
            <Row key={prop} className="assetCardTable_tr"> 
              <Col span={10} className="assetCardTable_td">
                <PropertyLabel iri={prop} factory={factory} warning={true} />
              </Col>
              <Col span={14} className="assetCardTable_td" style={{display: "block"}}>
                <FieldProxy 
                  factory={factory} lang={lang} 
                  subject={iri} predicat={prop} values={values} vselected={vselected}
                  onReload={(subject, predicat) => this.onReloadProxy(subject, predicat)}
                  getBaseRoutePath={this.props.getBaseRoutePath}
                  {...this.state}
                  {...linkProps}
                  action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
              </Col>
            </Row>
        )}
      {this.state.linkSelectModal && showSelectIndividual(this.formRef, iri, this.state.linkSelectPredicat, factory, lang, this.onSelectLinkOk, this.onSelectLinkCancel, vselected)}
      </span>
    )
  }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vindivid, vset, vselected} = state;
    const {lang} = props;
    return {
        lang: (lang)?lang: vset.lang,
        ...vindivid,
        vselected,
        factory: props.factory
    };
}
export default connect(
  mapStateToProps,
  dispatch => ({
    onReload(subject, graph){
      return dispatch(VocabsIndividual.loadIndividual(subject));
    },
    onSelected(type, subject, prdicat, object){
      return dispatch(RdfTriplet.SELECTED(type, subject, prdicat, object));
    },
    onInsertProperty(actions, subject, predicat, uri){
      return dispatch(actions.insertTripleURI(subject, predicat, uri));
    },
    onDeleteElement (actions, subject, predicat, object){
      return dispatch(actions.deleteTripleURI(subject, predicat, object));
    },
  })  
)(IndividualData);